export default "/images/ic-mapping-card.svg?a57294458ee8755576454a12cf251702";